<template>

	<section>
		<div class="elmapa" v-bind:id="'map_'+pagina.id" v-bind:lat="pagina.acf.mapa.lat" v-bind:lng="pagina.acf.mapa.lng"></div>
		<div class="flex-centermid mapa__descripcion">
			<p v-html="pagina.content.rendered"></p>
			<a v-bind:href="'https://www.google.com.py/maps/@'+pagina.acf.mapa.lat+','+pagina.acf.mapa.lng+'z'" class="como" target="_blank">Como llegar</a>
		</div>
	</section>


</template>


<script>
export default {
	props:[
		'pagina',
	],
	mounted: function() {
		this.iniciaMapa();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {
		iniciaMapa:function(){
			const vm = this;
			vm.$nextTick(function(){

				function elmapa(){
					var mapOptions = {
						zoom: 14,
						scrollwheel: false,
						navigationControl: false,
						mapTypeControl: false,
						scaleControl: false,
						draggable: true,
						center: new google.maps.LatLng(jQuery('.elmapa').attr('lat'),jQuery('.elmapa').attr('lng')),
						styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]
					};

					var marker_url = rtwp.theme_url+'/html/assets/img/location.png';
					var mapElement = document.getElementById(jQuery('.elmapa').attr('id'));
					var map = new google.maps.Map(mapElement, mapOptions);
					var marker = new google.maps.Marker({
						position: new google.maps.LatLng(jQuery('.elmapa').attr('lat'),jQuery('.elmapa').attr('lng')),
						map: map,
						icon: marker_url
					});
				}
				elmapa();
			});
		}
	},
	watch: {
	}
};
</script>



// WEBPACK FOOTER //
// page_mapa.vue?347fd2da